export const EDITORELEMENTID = 'slate-editor-container'
export const EDITOR_AREA = 'slate-editor-area'
export const EDITOR_ID = 'slate-editor-id'
export const TITLE_ID = 'slate-title-id'
export const HOVERING_TOOLBAR_ID = 'hovering-toolbar-container'
export const PLUGIN_CONTAINER_WIDTH = 480
